import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { connect } from 'react-redux';
import { selectors, api, featuredTypes } from '../../../redux/products/featured';

const PVOneRowProductSlider = loadable(() => import('./PVOneRowProductSlider'), {
    fallback: <div className="pv-spinner sm" />,
});

/*Once upon a time used by mini purchase history.ascx*/
const PVSuggestionsSlider = ({
    apiGetFeatured,
    items,
    loadComplete,
    featuredType,
    itemId,
    numProducts,
    prodDetail,
}) => {
    const typeDefinitions = {
        [featuredTypes.RECENT]: { heading: 'Recent Items', useItemId: false },
        [featuredTypes.SUGGESTED]: { heading: 'Suggested Items', useItemId: true },
        [featuredTypes.ALSOPURCHASED]: {
            heading: 'Customers who bought this also purchased',
            useItemId: true,
        },
        [featuredType.TOPBYUSER]: { heading: 'Top Items for You', useItemId: false },
        [featuredTypes.POPULAR]: { heading: 'Popular Items', useItemId: false },
    };

    const [header, setHeader] = useState('');
    const [itemIdRequired, setItemIdrequired] = useState(true);
    const isMounted = useRef(null);
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    useEffect(() => {
        const { heading, useItemId } = typeDefinitions[featuredType];
        if (isMounted.current) {
            setHeader(heading);
            setItemIdrequired(useItemId);
        }
    }, [featuredType]);

    const conditionallyGetItems = () => {
        const nonNullItems = (items || []).find((x) => Boolean(x));
        if (!nonNullItems && (itemId || !itemIdRequired)) {
            apiGetFeatured(numProducts, featuredType, itemId, prodDetail);
        }
    };
    useEffect(() => {
        conditionallyGetItems();
    }, [itemId, itemIdRequired]);

    return (
        <PVOneRowProductSlider
            loadComplete={loadComplete}
            items={items}
            heading={header}
            numProducts={numProducts}
        />
    );
};

PVSuggestionsSlider.propTypes = {
    apiGetFeatured: PropTypes.func.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
    loadComplete: PropTypes.bool,
    featuredType: PropTypes.string.isRequired,
    itemId: PropTypes.string,
    numProducts: PropTypes.number,
    prodDetail: PropTypes.bool,
};

PVSuggestionsSlider.defaultProps = {
    items: [],
    loadComplete: false,
    itemId: null,
    numProducts: 6,
    prodDetail: false,
};

const mapStateToProps = (state, ownProps) => {
    // const selectorOptions = { featuredType: ownProps.featuredType, loadItemId: ownProps.itemId };
    const selectorOptions = { featuredType: ownProps.featuredType, itemId: ownProps.itemId };
    return {
        items: selectors.selectFeaturedItems(state, selectorOptions),
        loadComplete: selectors.selectLoadCompleteForType(state, selectorOptions),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        apiGetFeatured: (numProducts, featuredType, itemId, prodDetail) => {
            dispatch(api.getFeaturedProducts(numProducts, '', featuredType, itemId, prodDetail));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PVSuggestionsSlider);

export { featuredTypes };
